import React from 'react';
import { cn } from '../../lib/cn';

export interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  padding?: number;
  accent?: boolean;
  hover?: boolean;
}

export function Card({ children, className, padding = 24, accent, hover, ...props }: CardProps) {
  return <div {...props} className={cn('relative rounded-[var(--r-xl)] border border-[var(--cream-2)] bg-[var(--cream-1)] shadow-[var(--sh-2)] transition duration-[180ms]', hover && 'hover:-translate-y-0.5 hover:shadow-[var(--sh-3)]', accent && 'border-t-[3px] border-t-[var(--ai-3)]', className)} style={{ padding }}>{children}</div>;
}
